import { gql } from '@apollo/client';

export const GET_STOCK_ROTATION_DAYS_HISTORY = gql`
  query GetStockRotationDaysHistory($vendorNames: [String!]!) {
    getStockRotationDaysHistory(vendorNames: $vendorNames) {
      dateISO8601
      vendorStockRotationDays
      marketStockRotationDays
    }
  }
`;
